
//interfaces
import { IWhitelistTerm} from '@/interfaces/languages';



const TermTableInformation = ({termInformation}:{termInformation: IWhitelistTerm}) => {
    return (
        <div className='term-table-information'>
            <span className='term-span'>
                {termInformation.text}
            </span>
            <span className='term-description'>
                {termInformation.description}
            </span>
        </div>
    );
};

export default TermTableInformation